import { z } from 'zod';

export enum LandingCardActionTypeEnum {
  Dispatch = 1,
  PromptInjection = 2,
  Custom = 3,
  Redirect = 4,
  PassResponseDirectlyToAgent = 5,
}

export const LandingCardActionTypeSchema = z.enum(LandingCardActionTypeEnum);
export type LandingCardActionType = z.infer<typeof LandingCardActionTypeSchema>;

export const dispatchActionDataSchema = z.object({});

export const promptInjectionActionDataSchema = z.object({
  prompt: z.string(),
});

export const redirectActionDataSchema = z.object({
  url: z.string(),
});

// Validation schema for the jsonData content when using PassResponseDirectlyToAgent - 
// this will need to be changed if we want anything other than subject configured to be passed to agent in landing card
export const agentResponseJsonDataSchema = z.object({
  subject: z.object({
    name: z.string().min(1, 'Name is required'),
    id: z.string().min(1, 'ID is required').refine(
      (val) => !isNaN(Number(val)),
      {
          error: 'ID must be a valid number'
    }
    ),
  }),
});

export const landingCardActionDataSchema = z.union([
  dispatchActionDataSchema,
  promptInjectionActionDataSchema,
  redirectActionDataSchema,
  agentResponseJsonDataSchema,
  z.null(),
]);

export type LandingCardActionData = z.infer<typeof landingCardActionDataSchema>;

export const accountLandingCardOverrideDataSchema = z.object({
  defaultCardId: z.number().nullable(),
}).nullable();

export const brandLandingCardOverrideDataSchema = z.union([
  z.object({
    defaultCardId: z.number(),
  }),
  z.object({
    accountCardId: z.number(),
  }),
]).nullable();

export const applicationLandingCardOverrideDataSchema = z.union([
  z.object({
    defaultCardId: z.number(),
  }),
  z.object({
    accountCardId: z.number(),
  }),
  z.object({
    brandCardId: z.number(),
  }),
]).nullable();

export const landingCardOverrideDataSchema = z.union([
  accountLandingCardOverrideDataSchema,
  brandLandingCardOverrideDataSchema,
  applicationLandingCardOverrideDataSchema,
  z.null(),
]);

export type AccountLandingCardOverrideData = z.infer<typeof accountLandingCardOverrideDataSchema>;
export type BrandLandingCardOverrideData = z.infer<typeof brandLandingCardOverrideDataSchema>;
export type ApplicationLandingCardOverrideData = z.infer<typeof applicationLandingCardOverrideDataSchema>;
export type LandingCardOverrideData = z.infer<typeof landingCardOverrideDataSchema>;

export const getActionTypeLabel = (actionType: LandingCardActionTypeEnum) => {
    switch (actionType) {
      case LandingCardActionTypeEnum.Dispatch:
        return 'Dispatch';
      case LandingCardActionTypeEnum.PromptInjection:
        return 'Prompt Injection';
      case LandingCardActionTypeEnum.Custom:
        return 'Custom';
      case LandingCardActionTypeEnum.Redirect:
        return 'Redirect';
      case LandingCardActionTypeEnum.PassResponseDirectlyToAgent:
        return 'Pass response directly to agent';
      default:
        return 'Unknown';
    }
  };
